import { render, staticRenderFns } from "./topAdvertisingSpace.vue?vue&type=template&id=1f53f81c&scoped=true"
import script from "./topAdvertisingSpace.vue?vue&type=script&lang=js"
export * from "./topAdvertisingSpace.vue?vue&type=script&lang=js"
import style0 from "./topAdvertisingSpace.vue?vue&type=style&index=0&id=1f53f81c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53f81c",
  null
  
)

export default component.exports